import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { CardComponent } from '../card/card.component';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { BackButtonComponent } from '../back-button/back-button.component';
import { LogoImagesComponent } from '../logo-images/logo-images.component';

@Component({
  selector: 'app-forgot-password-form',
  standalone: true,
  imports: [
    MatButtonModule,
    RouterModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    CardComponent,
    BackButtonComponent,
    LogoImagesComponent
  ],
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.scss']
})
export class ForgotPasswordFormComponent {
  forgotPasswordForm!: FormGroup<{
    email: FormControl<string | null>;
  }>;

  error: string | null = null;
  isLoading = false;
  requestSend = false;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  async onSubmit() {
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.error = null;
    this.forgotPasswordForm.disable();

    try {
      await lastValueFrom(this.authService.forgotPassword(this.forgotPasswordForm.value.email ?? ''));
      this.requestSend = true;
    } catch (error) {
      this.error = 'Er is iets misgegaan tijdens het verzoek.';
    } finally {
      this.isLoading = false;
      this.forgotPasswordForm.enable();
    }
  }
}
